import { darken, isTransparent, lighten } from '../../../../../../lib/color';
import { DEFAULT_GRADIENT_BASE_COLOR, GRADIENT_TYPES } from '../../../../constants';
import calcLinearGradient from '../calcLinearGradient';

/**
 * Returns the gradient style setting according the given color and gradientType
 * @param color
 * @param {GRADIENT_TYPES} gradientType
 * @return {String} - The gradient style property
 */
const getGradientBackgroundColor = (color, gradientType) => {
    const gradientColor = isTransparent(color) ? DEFAULT_GRADIENT_BASE_COLOR : color;

    switch (gradientType) {
        case GRADIENT_TYPES.LINEAR:
            return calcLinearGradient(gradientColor);
        case GRADIENT_TYPES.RADIAL:
            return `radial-gradient(circle, ${lighten(gradientColor, 0)} 30%, ${darken(gradientColor, 0.19)} 45%)`;
        default:
            throw Error('No gradientType was provided');
    }
};

export default getGradientBackgroundColor;
